import uploadsservicescriminalDefenseimageshutterstock_1811483884500x282Jpg from "$lib/data/generated/uploads/services/Criminal-Defense/image/shutterstock_1811483884 500x282.jpg";

export const uploads = {
  "uploads/services/Criminal-Defense/image/shutterstock_1811483884 500x282.jpg": uploadsservicescriminalDefenseimageshutterstock_1811483884500x282Jpg
};